import { style } from "../../../features/contract_period/ContractPeriodTabs/CurtailmentObjectTab/CurtailmentObject.style";
import { max, min } from "date-fns";
import _ from "lodash";
import { Box, Grid, IconButton } from "@mui/material";
import Tag from "../Tag/Tag";
import { Spacer } from "../Spacer";
import { formatDate } from "../../utils/dateUtils";
import CurtailmentDataList from "../../../features/contract_period/ContractPeriodTabs/CurtailmentObjectTab/CurtailmentDataList";
import CurtailmentObjectDetailsModal from "../../../features/contract_period/ContractPeriodTabs/CurtailmentObjectTab/CurtailmentObjectDetailsModal";
import CurtailmentObjectAuditModal from "../../../features/contract_period/ContractPeriodTabs/CurtailmentObjectTab/CurtailmentObjectAuditModal";
import  DetailsIcon from "../../assets/icons/details.svg";
import  HistoryIcon from "../../assets/icons/history.svg";
import { useState } from "react";
import { CurtailmentObjectGroupType } from "../../../features/contract_period/ContractPeriodTabs/CurtailmentObjectTab/CurtailmentObject.types";
import { CurtailmentObjectSubtypeType } from "../../../requests_cm/gecoContractsService/types";
import CommentIcon from "@mui/icons-material/Comment";
import ActivityLogModal from "../ActivityLogModal/ActivityLogModal";
import { CommentObjectClass } from "../../../requests_cm/gepoCommentService/types";
import { CurtailmentObjectType } from "../../../requests_cm/gecoSitesService/types";

const CurtailmentObjects = ({
	curtailmentObjectGroup,
}: {
	curtailmentObjectGroup: CurtailmentObjectGroupType | undefined;
}) => {
	const [openDetailModal, setOpenDetailModal] = useState<string | null>();
	const [openAuditModal, setOpenAuditModal] = useState<string | null>();
	const [selectedActivity, setSelectedActivity] =
		useState<CurtailmentObjectType | null>(null);
	return (
		<Box sx={style.collapseWrapper}>
			{curtailmentObjectGroup?.curtailmentKinds.map((curtailmentKind) => {
				const curtailmentObjects = curtailmentObjectGroup.data.filter(
					(curtailmentObject) =>
						curtailmentObject.curtailment_kind === curtailmentKind
				);

				const startDate = min(
					_.chain(curtailmentObjects)
						.map("start_date")
						.filter((date) => !!date && !isNaN(Date.parse(date)))
						.map((date) => new Date(date))
						.value()
				);

				const endDate = max(
					_.chain(curtailmentObjects)
						.map("end_date")
						.filter((date) => !!date && !isNaN(Date.parse(date)))
						.map((date) => new Date(date))
						.value()
				);

				return (
					<Box
						key={curtailmentKind}
						sx={style.curtailmentKindWrapper}
					>
						<Tag label={curtailmentKind} />
						<Spacer gap={8} />
						<Box sx={style.dataTitle}>Horizon</Box>
						{formatDate(startDate, "yyyy/MM/dd")} -{" "}
						<b>{formatDate(endDate, "yyyy/MM/dd")}</b>
						<Spacer gap={8} />
						<Box sx={style.curtailmentObjectList}>
							{curtailmentObjects.map((curtailmentObject) => (
								<CurtailmentDataList
									key={curtailmentObject.id}
									wrapperSx={style.curtailmentObject}
									list={[
										{
											value: (
												<Grid container>
													<Box
														sx={{
															...style.cartridge,
															...(curtailmentObject.curtailment_object_subtype ===
															CurtailmentObjectSubtypeType.GRID
																? style.brandCartridge
																: {}),
														}}
													>
														{
															curtailmentObject.curtailment_object_subtype
														}
													</Box>
													<Box sx={{mt: "-7px"}}>
														<IconButton
															onClick={() =>
																setSelectedActivity(curtailmentObject)
															}
														>
															<CommentIcon />
														</IconButton>
													</Box>
												</Grid>												
											),
										},
										{
											label: "Compensation Method",
											value: curtailmentObject.compensation_method ?? (
												<br />
											),
										},
										{
											label: "Pricing Method",
											value: curtailmentObject.pricing_method ?? (
												<br />
											),
										},
										{
											label: "Curtailment Price",
											value: curtailmentObject.curtailment_price ?? (
												<br />
											),
										},
										{
											label: "Invoice Price",
											value: curtailmentObject.invoice_price,
										},
										{
											label: "Index",
											value: curtailmentObject.commodity_index ?? (
												<br />
											),
										},
										{
											label: "Virtual Portfolio",
											value: curtailmentObject.virtual_portfolio ?? (
												<br />
											),
										},
									]}
								/>
							))}
						</Box>
						<Box sx={style.iconsWrapper}>
							<Box sx={style.icon}>
								<IconButton
									onClick={() =>
										setOpenDetailModal(curtailmentKind)
									}
								>
									<DetailsIcon />
								</IconButton>
							</Box>
							<Box sx={style.icon}>
								<IconButton
									onClick={() =>
										setOpenAuditModal(curtailmentKind)
									}
								>
									<HistoryIcon />
								</IconButton>
							</Box>
						</Box>
						<CurtailmentObjectDetailsModal
							curtailmentKind={curtailmentKind}
							curtailmentObjectGroup={curtailmentObjectGroup}
							curtailmentObjects={curtailmentObjects}
							setOpenModal={setOpenDetailModal}
							setOpenAuditModal={setOpenAuditModal}
							openModal={openDetailModal === curtailmentKind}
						/>
						<CurtailmentObjectAuditModal
							curtailmentObjectGroup={curtailmentObjectGroup}
							curtailmentObjects={curtailmentObjects}
							setOpenModal={setOpenAuditModal}
							openModal={openAuditModal === curtailmentKind}
						/>
					</Box>
				);
			})}
			<ActivityLogModal
				isOpen={selectedActivity !== null}
				onClose={() => setSelectedActivity(null)}
				resourceId={selectedActivity?.id}
				resourceName={selectedActivity?.name}
				resource="curtailment_object"
				resourceLabel="CurtailmentObject"
				commentObjectClass={CommentObjectClass.NOT_SUPPORTED}
				title="Log History for curtailment object"
			/>
		</Box>
	);
};

export default CurtailmentObjects;
